// eslint-disable-next-line import/prefer-default-export
// export function nFormatter(num, digits) {
//   const lookup = [
//     { value: 1, symbol: '' },
//     { value: 1e3, symbol: 'K' },
//     { value: 1e6, symbol: 'M' },
//     { value: 1e9, symbol: 'G' },
//     { value: 1e12, symbol: 'T' },
//     { value: 1e15, symbol: 'P' },
//     { value: 1e18, symbol: 'E' }
//   ];
//   const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
//   const item = lookup
//     .slice()
//     .reverse()
//     // eslint-disable-next-line func-names
//     .find(function (it) {
//       return num >= it.value;
//     });
//   return item ? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol : '0';
// }

export const nFormatter = (n, digits = 2) => {
  if (n < 1e3) return n;
  if (n >= 1e3 && n < 1e6) return `${+(n / 1e3).toFixed(digits)}K`;
  if (n >= 1e6 && n < 1e9) return `${+(n / 1e6).toFixed(digits)}M`;
  if (n >= 1e9 && n < 1e12) return `${+(n / 1e9).toFixed(digits)}B`;
  if (n >= 1e12) return `${+(n / 1e12).toFixed(digits)}T`;
  return n;
};

export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function detectError(error) {
  let message = '';
  if (error?.response) {
    if (Array.isArray(error.response.data?.message)) {
      message = error.response.data.message.join('\n');
    } else {
      message = error?.response.data?.message;
      if (!message) {
        message = error?.response.data?.messsage;
      }
    }
  }

  // if (Array.isArray(error.response.data)) {
  //   const errorArray = error.response.data;
  //   const errorObject = errorArray[1];
  //   // improper way of handling these errors. Added enough frontend catch to prevent these errors
  //   // [phone, performance];
  //   // eslint-disable-next-line prefer-destructuring
  //   message = errorObject.phone[0];
  // }

  if (!message) {
    message = 'Something went wrong';
  }

  return message;
}

export function convertTons(valueInKilograms) {
  // Check if the value is greater than 1000
  if (valueInKilograms < 1000) {
    // Return the value in kilograms
    return `${valueInKilograms} KG`;
  }
  // Convert the value to tons and return
  const valueInTons = valueInKilograms / 1000;
  return `${valueInTons} tons`;
}
